import { render, staticRenderFns } from "./NewCirclePropertyEditor.vue?vue&type=template&id=2d3f9c0e&scoped=true&"
import script from "./NewCirclePropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./NewCirclePropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3f9c0e",
  null
  
)

export default component.exports